import React, { useState, useEffect } from 'react';
import { useIntl, getLocale } from 'umi';
import { Segment, Icon } from 'tea-component';
import './index.scss';
import ArrowBottom from '@/pages/intelligence/assets/svg/selectIcon/arrow-bottom.svg';
import { mapColor } from '@/pages/intelligence/pages/MarketProfile/_config/Const';
import { mapZoom, sortArrDesc } from '@/pages/intelligence/pages/MarketProfile/_util';
import { formatNum } from '@/pages/intelligence/utils/commonUtils';
import * as echarts from 'echarts';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import { lineColor } from '@/pages/intelligence/pages/MarketProfile/_config/Const';
import { importJSON } from '@/pages/intelligence/utils/echartsUtils';
// import nameMap from '@/pages/dashboard/components/MapEchart/_config/nameMap.json'
import { getPieces } from '../../_util';

export default function ChartContent(props: any) {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const {
    options,
    sortbyText,
    activeTab,
    pageId,
    mainSegment = 'Revenue',
    onSegmentChange,
    mapData1,
    mapData2,
    mapData3,
    mapData4,
    selectedKeys,
    lineTrendData,
    chartType,
    selectedKeysColor,
    regionsCountries,
  } = props;

  const [map, setMap] = useState();
  const isEN = getLocale() === 'en-US';
  const allMarkets = regionsCountries?.map((area: any) => area.country_set).flat() || [];
  const toTranslateCountry = (code: string) => {
    return allMarkets.find(
      (country: any) => country.country_name_en?.toLocaleLowerCase() === code?.toLocaleLowerCase(),
    )?.[isEN ? 'country_name_en' : 'country_name_ch'];
  };
  const getMapChart = async () => {
    try {
      if (echarts.getMap('world')) {
        // console.log("MAP exist")
      } else {
        const map = (await importJSON(
          'https://ogdb-cdn.intlgame.cn/front/static/world.json',
        )) as any;
        setMap(map);
        echarts.registerMap('world', map);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getMapChart();
  }, []);

  const worldMapExample = (data: any, containId: string, mapColor: any, seriesName?: string) => {
    let chartDom = document.getElementById(containId);
    if (chartDom) {
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart == null) {
        myChart = echarts.init(chartDom);
      }
      //地图
      // echarts.registerMap('world', map);
      //中英文地名
      const dealData =
        data?.map((item: any) => ({
          ...item,
          name: toTranslateCountry(item.name),
        })) || [];

      const backNameMap = {} as any;
      allMarkets?.forEach((country: any) => {
        backNameMap[country.country_name_en] = country.country_name_ch;
      });

      let tapeoption = {
        tooltip: {
          trigger: 'item',
          padding: 0,
          borderWidth: 0,
          formatter: (params) => {
            return mapTooltip(params);
          },
          label: { show: false },
          backgroundColor: 'rgba(0,0,0,0)'
        },
        visualMap: [
          {
            realtime: false,
            calculable: false,
            type: 'piecewise',
            min: 0,
            max: 10000000000,
            itemWidth: 14,
            itemHeight: 40,
            inverse: false,
            itemGap: 0,
            itemSymbol: 'rect',
            top: '8%',
            left: '1%',
            // textGap:10,
            textStyle: {
              lineHeight: 40,
              color: '#838697',
              fontSize: 14,
            },
            //点击后的颜色
            outOfRange: {
              color: '#ffdf33',
              symbolSize: [30, 100],
            },
            pieces: getPieces(data),
          },
        ],
        series: [
          {
            type: 'map',
            mapType: 'world',
            roam: 'move',
            itemStyle: {
              normal: {
                borderColor: 'rgba(190, 190, 190,0.5)',
                borderWidth: 1,
                areaColor: '#f2f2f2',
              },
              emphasis: {
                // borderColor: '#000',
                // borderWidth: 1.5,
                label: { show: false },
                itemStyle: {
                  borderColor: '#000',
                  borderWidth: '2',
                  borderType: 'solid',
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  shadowBlur: 10,
                },
              },
            },
            data: dealData,
            nameMap: getLocale() === 'zh-CN' ? backNameMap : null,
          },
        ],
      };
      tapeoption && myChart.setOption(tapeoption, true);
      myChart.resize();
    }
  };

  const mapTooltip = (params: any) => {
    let mapSerieName = localStorage.getItem('mpMapSerieName');
    let name =
      mapSerieName == 'Downloads'
        ? `${formatMessage({ id: 'dbi_downloads' })}:`
        : mapSerieName == 'TotalRevenue'
        ? `${formatMessage({ id: 'dbi_total_rev' })}:`
        : mapSerieName == 'TotalPlayer'
        ? `${formatMessage({ id: 'dbi_total_player' })}:`
        : `${formatMessage({ id: 'dbi_revenue_$' })}:`;

    return ChartBubble({
      data: params,
      titleNow: '',
      topChartsType: 'marketProfile-map',
      imageType: 'mobile',
      leftContent: formatMessage({ id: 'dbi_market_total_game' }),
      //   chartType,
      headerLeftTitle: name,
      dateType: 'month',
      ifNoBarImg: true,
    });
  };

  const refreshMapData = (containId: string, data: any, isRevenue?: boolean) => {
    const dealData =
      data?.map((item: any) => ({
        ...item,
        name: toTranslateCountry(item.name),
      })) || [];
    let chartDom = document.getElementById(containId);
    if (chartDom) {
      let myChart = echarts.getInstanceByDom(chartDom);
      let option = myChart.getOption();
      option.visualMap[0].pieces = getPieces(data);
      option.series[0].data = dealData;
      myChart.setOption(option);
      myChart.resize();
    }
  };

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    const renderData = {
      MarketProfilMobile: { Revenue: mapData1, Downloads: mapData2 },
      MarketProfilPC: {
        Digital: mapData1,
        Physical: mapData2,
        TotalRevenue: mapData3,
        TotalPlayer: mapData4,
      },
      MarketProfilConsole: {
        Digital: mapData1,
        Physical: mapData2,
        TotalRevenue: mapData3,
        TotalPlayer: mapData4,
      },
    } as any;
    if (echarts.getMap('world')) {
      worldMapExample(
        pageId == 'MarketProfilAnnualReport' ? mapData1 : renderData[pageId][mainSegment],
        'mpGameMap' + pageId,
        mapColor,
      );
    }
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [map, mapData1, mapData2, mapData3, mapData4, regionsCountries]);

  //窗口变化调整布局 提取
  const resizeHandler = () => {
    let mapDom = document.getElementById('mpGameMap' + pageId);
    if (mapDom) {
      let mapChart = echarts.init(mapDom);
      try {
        mapChart.resize();
      } catch (e) {}
    }

    let lineDom = document.getElementById('mpAnnualSummaryCharts');
    if (lineDom) {
      let lineChart = echarts.init(lineDom);
      try {
        lineChart.resize();
      } catch (e) {}
    }
  };

  //折线图
  const drawLine = (titleNow = '') => {
    let chartTempData = [] as any;
    let value = localStorage.getItem('mpMapSerieName');
    // console.log('lineTrendData',lineTrendData);

    let aAxis =
      lineTrendData[value == 'TotalRevenue' || value == 'TotalPlayer' ? 'totalAxis' : 'xAxis'];
    let itemKey = '';
    switch (value) {
      case 'Revenue':
        itemKey = 'revenue';
        break;
      case 'Downloads':
        itemKey = 'download';
        break;
      case 'Digital':
        itemKey = 'digitalRevenue';
        break;
      case 'Physical':
        itemKey = 'physicalRevenue';
        break;
      case 'TotalRevenue':
        itemKey = 'totalRevenue';
        break;
      case 'TotalPlayer':
        itemKey = 'totalPlayer';
        break;
    }
    selectedKeys.map((item, index) => {
      let data = lineTrendData[item.gameId];
      if (data) {
        let obj = {
          name: toTranslateCountry(item.gameId) || item.gameId,
          type: 'line',
          data: data[itemKey],
          color: lineColor[index],
        };
        chartTempData.push(obj);
      }
    });
    drawLineChart('mpGameMap' + pageId, chartTempData, aAxis, titleNow);
  };

  const drawLineChart = (containId: string, data: any, xAxis: any, titleNow: string) => {
    let chartDom = document.getElementById(containId);
    if (chartDom) {
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart == null) {
        myChart = echarts.init(chartDom);
      }
      const lineFormatterTooltip = (params: any) => {
        return ChartBubble({
          data: params?.sort(sortArrDesc('value')),
          headerLeftTitle: '',
          titleNow,
          topChartsType: 'marketProfile-line',
          imageType: 'mobile',
          chartType: 'line',
          dateType: 'month',
          ifNoBarImg: true,
        });
      };

      let option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          padding: 0,
          borderWidth: 0,
          formatter: lineFormatterTooltip,
          backgroundColor: 'rgba(0,0,0,0)'
        },
        legend: {
          show: true,
          bottom: 0,
          lineStyle: {
            opacity: 0,
          },
          icon: 'circle',
          type: 'scroll',
          itemWidth: 8,
        },
        grid: {
          top: '20px',
          left: '0%',
          right: '2%',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: xAxis,
            axisTick: { alignWithLabel: true },
            axisLine: {
              color: 'rgba(0,0,0,0.45)',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: 'rgba(0,0,0,0.45)',
              formatter: function (value, index) {
                return formatNum(value);
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: '#E9E9E9',
              },
            },
          },
        ],
        series: data,
      };
      option && myChart.setOption(option, true);
      myChart.resize();
    }
  };

  //chartType改变
  useEffect(() => {
    let value = localStorage.getItem('mpMapSerieName');
    if (chartType == 'chart-map') {
      let mapData = [] as any;
      if (value == 'Revenue' || value == 'Digital') {
        mapData = mapData1;
      } else if (value == 'Downloads' || value == 'Physical') {
        mapData = mapData2;
      } else if (value == 'TotalRevenue') {
        mapData = mapData3;
      } else if (value == 'TotalPlayer') {
        mapData = mapData4;
      }
      if (echarts.getMap('world')) {
        worldMapExample(mapData, 'mpGameMap' + pageId, mapColor);
      }
    } else if (chartType == 'discount-chart' && selectedKeys.length > 0) {
      drawLine(mainSegment);
    }
  }, [chartType, locale]);

  useEffect(() => {
    if (chartType == 'discount-chart' && selectedKeys.length > 0) {
      drawLine(mainSegment);
    }
  }, [selectedKeys, selectedKeysColor, regionsCountries, locale]);

  //地图数据重新渲染`
  const changeSegment = (value: any) => {
    onSegmentChange(value);
    localStorage.setItem('mpMapSerieName', value);
    if (chartType == 'discount-chart') {
      drawLine(value);
    } else {
      if (value == 'Revenue' || value == 'Digital') {
        refreshMapData('mpGameMap' + pageId, mapData1, true);
      } else if (value == 'Downloads' || value == 'Physical') {
        refreshMapData('mpGameMap' + pageId, mapData2);
      } else if (value == 'TotalRevenue') {
        refreshMapData('mpGameMap' + pageId, mapData3);
      } else if (value == 'TotalPlayer') {
        refreshMapData('mpGameMap' + pageId, mapData4);
      }
    }
  };

  return (
    <div className="chart-con">
      <div className="tablecard-filter">
        {options ? (
          <Segment
            value={mainSegment}
            onChange={(value) => changeSegment(value)}
            options={options}
          />
        ) : (
          ''
        )}
        {sortbyText ? (
          <div className="tablecard-txt">
            <span className="tablecard-txt-text">{sortbyText}</span>
            <div className="tablecard-txt-icon">
              ( <img src={ArrowBottom} alt="" /> )
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="echarts-line worldMap">
        <div className="mpGameMapMain" id={'mpGameMap' + pageId}></div>
        {activeTab === 'chart-map' && (
          <div className="control">
            <span
              className="control-icon"
              onClick={() => {
                mapZoom('mpGameMap' + pageId, 'zoomIn');
              }}
            >
              <Icon type="plus" />
            </span>
            <span
              className="control-icon"
              onClick={() => {
                mapZoom('mpGameMap' + pageId, 'zoomOut');
              }}
            >
              <Icon type="minus" />
            </span>
          </div>
        )}
        {/* {activeTab === 'chart-map' && (
              <div className="mpGameMapTooltips">
                <div className={'mpMapTooltipsMain'}>
                  {mapColor.map((item) => {
                    return (
                      <div
                        className={'mpMapTooltipsMainItem'}
                        style={{ backgroundColor: item }}
                      ></div>
                    );
                  })}
                </div>
                <div className={'mpMapTooltipsMain mpMapTooltipsMain2'}>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    0
                  </div>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    $100K
                  </div>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    $1M
                  </div>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    $10M
                  </div>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    $100M
                  </div>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    $1B
                  </div>
                  <div
                    className={'mpMapTooltipsMainItem mpMapTooltipsMainItem2'}
                  >
                    $10B
                  </div>
                </div>
              </div>
            )} */}
      </div>
    </div>
  );
}
